import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmergencyContactComponent } from './emergency-contact.component';
import { CardModule } from 'libraries/ui_card/card.module';
import { FormFieldModule } from 'libraries/module/formbuilder/fields/form-field/form-field.module';
import { ReactiveFormsModule } from '@angular/forms';
import { SimpleSelectModule } from 'libraries/module/formbuilder/fields/simple-select/simple-select.module';
import { PhonePrefixModule } from 'libraries/service/phone-prefix/phone-prefix.module';
import { NumberModule } from 'libraries/module/formbuilder/fields/number/number.module';
import { TextModule } from 'libraries/module/formbuilder/fields/text/text.module';
import { ComboboxFieldModule } from 'libraries/module/formbuilder/fields/combobox-field/combobox-field.module';
import { LocalizedModule } from "libraries/pipes/localized/localized.module";

@NgModule({
    imports: [
        CardModule,
        ComboboxFieldModule,
        CommonModule,
        FormFieldModule,
        LocalizedModule,
        NumberModule,
        PhonePrefixModule,
        ReactiveFormsModule,
        SimpleSelectModule,
        TextModule,
    ],
    declarations: [
        EmergencyContactComponent,
    ],
    exports: [
        EmergencyContactComponent,
    ],
})
export class EmergencyContactModule { }
